import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import axios from "axios";
import {Status} from "./status";
import {headers} from "./headers";
import {Component} from "./setting";
import {Asset, Reference, Tag} from "./fields";
import {host} from "./api";

export interface ComponentState {
    component?: Component,
    status: Status,
    error: string | null | undefined
}

const initialState: ComponentState = {
    component: undefined,
    status: Status.Idle,
    error: null,
}

export const saveSettingComponent = createAsyncThunk('saveSettingComponent', async (params: { settingId: number, projectId: number, component: Component }) => {
    const response = await axios.post(`${host}/settings/${params.settingId}/components`,
        params.component,
        {
            headers: headers(params.projectId.toString())
        })
    return response.data
})

export const saveLoreComponent = createAsyncThunk('saveLoreComponent', async (params: { loreId: number, projectId: number, component: Component }) => {
    const response = await axios.post(`${host}/lores/${params.loreId}/components`,
        params.component,
        {
            headers: headers(params.projectId.toString())
        })
    return response.data
})

export const deleteComponent = createAsyncThunk('deleteComponent', async (params: { projectId: number, componentId: number }) => {
    const response = await axios.delete(`${host}/components/${params.componentId}`, {
        headers: headers(params.projectId.toString())
    })
    return response.data
})

export const addComponentAsset = createAsyncThunk('addComponentAsset', async (params: { projectId: number, componentId: number, asset: Asset }) => {
    const response = await axios.post(`${host}/components/${params.componentId}/assets`,
        params.asset,
        {
            headers: headers(params.projectId.toString())
        })
    return response.data
})

export const addComponentReference = createAsyncThunk('addComponentReference', async (params: { projectId: number, componentId: number, reference: Reference }) => {
    const response = await axios.post(`${host}/components/${params.componentId}/references`,
        params.reference,
        {
            headers: headers(params.projectId.toString())
        })
    return response.data
})

export const addComponentTag = createAsyncThunk('addComponentTag', async (params: { projectId: number, componentId: number, tag: Tag }) => {
    const response = await axios.post(`${host}/components/${params.componentId}/tags`,
        params.tag,
        {
            headers: headers(params.projectId.toString())
        })
    return response.data
})

export const removeComponentAsset = createAsyncThunk('removeComponentAsset', async (params: { projectId: number, assetId: number }) => {
    const response = await axios.delete(`${host}/assets/${params.assetId}`,
        {
            headers: headers(params.projectId.toString())
        })
    return response.data
})

export const removeComponentReference = createAsyncThunk('removeComponentReference', async (params: { projectId: number, referenceId: number }) => {
    const response = await axios.delete(`${host}/references/${params.referenceId}`,
        {
            headers: headers(params.projectId.toString())
        })
    return response.data
})

export const removeComponentTag = createAsyncThunk('removeComponentTag', async (params: { projectId: number, componentId: number, tagId: number }) => {
    const response = await axios.delete(`${host}/components/${params.componentId}/tags/${params.tagId}`,
        {
            headers: headers(params.projectId.toString())
        })
    return response.data
})

export const componentSlice = createSlice({
    name: 'components',
    initialState,
    reducers: {
        setComponent: (state, action) => {
            state.component = action.payload
        }
    },
    extraReducers(builder) {
        builder
            .addCase(saveSettingComponent.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(saveSettingComponent.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(addComponentAsset.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(addComponentAsset.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(addComponentReference.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(addComponentReference.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(addComponentTag.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(addComponentTag.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(removeComponentAsset.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(removeComponentAsset.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(removeComponentReference.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(removeComponentReference.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(removeComponentTag.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(removeComponentTag.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(deleteComponent.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(deleteComponent.fulfilled, (state, action) => {
                state.status = Status.Idle
            })

    }
})

export const {setComponent} = componentSlice.actions

export default componentSlice.reducer;